<template>
  <div>
    <van-cell
      class="header"
      title="激励账单"
      title-class="name"
      :value="`${totalAmount}元`"
      value-class="value"
      center
    />
    <long-list
      class="info-panel"
      :api-method="getData"
    >
      <template #default="{list}">
        <mtd-table
          v-if="list&&list.length"
          :data="list"
          bordered
          striped
        >
          <mtd-table-column
            v-for="item in columns"
            :key="item.label"
            v-bind="item"
          />
        </mtd-table>
        <NoBillTips
          v-else
          msg="暂无数据"
        />
      </template>
    </long-list>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import NoBillTips from '@/components/NoBillTips';
import BillApi from '@/api/bill';
import { formatAmount, formatTableColumns } from '@/util/filter';

export default {
  name: 'BonusAmount',
  components: { NoBillTips },
  data() {
    return {
      columns: formatTableColumns([
        {
          label: '交易月份',
          prop: 'cutMonth',
        },
        {
          label: '门店名称',
          prop: 'poiName',
        },
        {
          label: '基数(元)',
          formatter: (row) => formatAmount(row.baseAmount),
        },
        {
          label: '金额(元)',
          formatter: (row) => formatAmount(row.bonusAmount),
        },
      ]),
    };
  },
  computed: {
    ...mapState('billModule', {
      billInfo(state) {
        if (this.$route.query.from === 'billed') {
          return state.currentBilledInfo;
        } else {
          return state.currentUnbilledInfo;
        }
      },
    }),
    totalAmount() {
      const { bonusAmount } = this.$route.query;
      return formatAmount(bonusAmount);
    },
  },
  methods: {
    formatAmount,
    async getData(pageNum, pageSize) {
      const { cutMonth: billMonth, customerId } = this.billInfo;
      const params = {
        customerId,
        billMonth,
        pageNum,
        pageSize,
      };
      return BillApi.getBonusDetail(params);
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  background: none;
  .name{
    font-weight: bold;
    font-size: 30px;
    color: black;
    text-align: left;
  }
  .value {
    // @extend .name;
    // font-weight: normal;
    // color: blue;
    // text-align: right;
  }
}
.table{
  width: 100%;
  td {
    width: 33.33%;
  }
}

</style>
